import { useEffect } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee, { Philosophy } from "@/components/site/Philosophy";
import Collection from "@/components/site/Collection";
import { Artisanship, SommelierClub } from "@/components/site/EditorialSections";
import SocialProofMap from "@/components/site/SocialProofMap";
import RegistryShowcase from "@/components/site/RegistryShowcase";
import FaqSection from "@/components/site/FaqSection";
import ScrollProgress from "@/components/site/ScrollProgress";
import { TerraArsa, Scilla, Claire, Blanche } from "@/components/site/WineSections";
import TerritoryParallax from "@/components/site/TerritoryParallax";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import { initAnalytics } from "@/lib/analytics";

export default function Landing() {
  useEffect(() => {
    initAnalytics();
  }, []);
  return (
    <main className="bg-white text-[#0A0A0A]" data-testid="landing-page">
      <Navbar />
      <ScrollProgress />
      <Hero />
      <Marquee />
      <Collection />
      <Philosophy />
      <TerritoryParallax />
      <TerraArsa />
      <Scilla />
      <Blanche />
      <Claire />
      <Artisanship />
      <SommelierClub />
      <SocialProofMap />
      <RegistryShowcase />
      <FaqSection />
      <Contact />
      <Footer />
    </main>
  );
}
